// extracted by mini-css-extract-plugin
export default {"error404":"style_error404__bTC43","title":"style_title__cEAMc","message":"style_message__goPWc","type":"style_type__udi1x"};